import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAgent?: boolean;
  requireAdmin?: boolean;
  userOnly?: boolean;
}

export default function ProtectedRoute({
  children,
  requireAgent = false,
  requireAdmin = false,
  userOnly = false,
}: ProtectedRouteProps) {
  const { user, loading, isAgent, isAdmin } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  if (requireAgent && !isAgent) {
    return <Navigate to="/" replace />;
  }

  // Block agents/admins from accessing user-only routes
  if (userOnly && isAgent) {
    return <Navigate to="/agent" replace />;
  }

  return <>{children}</>;
}
